module.exports = __webpack_public_path__ + "static/media/mappin.bca57380.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/svg/icons/mappin.svg
// module id = 2029
// module chunks = 0